import { Component, Input, OnInit, Output, EventEmitter, inject, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { AuthService, User } from '../../../core/service/auth/auth.service';
import { TitleService } from '../../../core/service/title-service/title.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() federationLogoUrl: string | null = null;
  @Input() accessLevel: 'full' | 'readonly' | 'blocked' = 'full';
  @Output() logoutEvent = new EventEmitter<void>();

  private titleService = inject(TitleService);
  private authService = inject(AuthService);

  pageTitle = this.titleService.pageTitle;
  // logo URL that failed to load: hidden instead of showing a broken image
  failedLogo: string | null = null;
  currentUser: User | null = null;

  get isFederationView(): boolean {
    return this.authService.isFederation();
  }

  private currentUrl = toSignal(this.routerEvents(), { initialValue: '' });

  // Caption above the title: which zone the page belongs to (the sidebar card is where the federation is changed)
  zoneCaption = computed(() => {
    if (this.currentUrl().startsWith('/plateforme')) return 'Plateforme';
    const acr = this.authService.currentFederation()?.federation_acornyme;
    return acr ? `Backoffice · ${acr}` : 'Backoffice';
  });

  constructor(
    private router: Router
  ) {}

  private routerEvents() {
    const router = inject(Router);
    return router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(e => e.urlAfterRedirects),
      startWith(router.url),
    );
  }

  ngOnInit(): void {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  logout(): void {
    this.logoutEvent.emit();
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/']);
      },
      error: () => {
        this.router.navigate(['/']);
      }
    });
  }

  getBadgeColor(userType: string): string {
    const colors: { [key: string]: string } = {
      'CLUB': 'bg-blue-500',
      'LEAG': 'bg-amber-500',
      'FEDE': 'bg-emerald-500',
      'ADMI': 'bg-purple-500'
    };
    return colors[userType] || 'bg-stone-500';
  }
}
